import { render, staticRenderFns } from "./BaseScopedListItem.vue?vue&type=template&id=9f12e3b8&scoped=true"
import script from "./BaseScopedListItem.vue?vue&type=script&lang=js"
export * from "./BaseScopedListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseScopedListItem.vue?vue&type=style&index=0&id=9f12e3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f12e3b8",
  null
  
)

export default component.exports